<template>
    <div>
        <!-- Modal -->
        <div class="modal-container" :class="{nqt__mb: mobile}" style="--m-background: transparent;">
            <div class="modal" :class="{nqt__mb: mobile}">
                <h1 class="modal__title">{{data.type == 0 ? this.$t("manage.presentList") : this.$t("manage.absentList")}}</h1>
                <div class="modal__content" :class="[{leng1: students.length != 1}, {nqt__mb: mobile}]">
                    <template v-for="(item, index) in students">
                        <div class="card" :key="index">
                            <div class="avatar">
                                <img v-if="item.avatar" :src="item.avatar" />
                                <img v-else-if="item.avatar == null && item.sex == 2" src="../../../static/images/SA-ava-nu.png" alt="Nu"/>
                                <img v-else-if="item.avatar == null && item.sex == 1" src="../../../static/images/profile.jpg" alt="Nam"/>
                                <img v-else-if="item.avatar == null && item.sex == ''" src="../../../static/images/profile.jpg" alt="Nam"/>
                            </div>
                            <div class="card__content">
                                <p class="card__name">{{item.studentName}}</p>
                                <p class="card__email">{{item.email}}</p>
                                <p class="card__email">{{item.studyTime}}</p>
                            </div>
                        </div>
                    </template>
                </div>
                <a @click="closeModal()" class="btn__close__modal"></a>
            </div>
        </div>
        <!-- Bg-close -->
        <div @click="closeModal()" class="bg__close__modal"></div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    export default {
        name: "popup",
        props: {
            data: {
                type: Object,
            }
        },
        data() {
            return {
                students: []
            };
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile
            }),
        },
        created () {
            this.init();
        },
        methods: {
            init: async function () {
                if (this.data.type == 0) {
                    this.students = await this.getLiveCourseParticipantList(this.data.courseLiveId);
                } else {
                    this.students = await this.getLiveCourseNonParticipantList(this.data.courseLiveId);
                }
            },

            // Lấy danh sách học viên đã tham gia
            getLiveCourseParticipantList: function (courseLiveId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getLiveCourseParticipantList", {
                            courseId: courseLiveId,
                        })
                        .then((response) => {
                            let listStudents = [];
                            response.data.forEach(el => {
                                if (el.userType == '2') {
                                    listStudents.push(el)
                                }
                            })
                            resolve(listStudents);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Lấy danh sách học viên chưa tham gia
            getLiveCourseNonParticipantList: function (courseLiveId) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getLiveCourseNonParticipantList", {
                            courseId: courseLiveId,
                        })
                        .then((response) => {
                            let listStudents = [];
                            response.data.forEach(el => {
                                if (el.userType == '2') {
                                    listStudents.push(el)
                                }
                            })
                            resolve(listStudents);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Đóng popup
            closeModal: function () {
                this.$emit('close', true);
            }
        },
    };
</script>


<style scoped>

/* modal */
.modal-container {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 10;
    justify-content: center;
    align-items: center;
    /* --m-background is set as inline style */
    background: var(--m-background);

    transform: translate(-50%, -50%);
}
.modal-container.nqt__mb {
    position: fixed !important;
    width: 100% !important;
    padding: 5px;
}

.modal.nqt__mb {
    width: 100% !important;
}

.modal-container:target {
    display: flex;
}

.modal {
    width: 60rem;
    padding: 1rem 2rem 1rem 1rem;
    border-radius: 0.8rem;

    color: var(--light);
    background: #ffffff;
    box-shadow: 0px 0px 7px 4px #888888;
    position: relative;

    overflow: hidden;
    max-height: 380px;
}

.modal__title {
    font-size: 3.2rem;
    color: black;
    margin-left: 1rem;
}

.modal__btn {

    margin-top: 1rem;
    margin-left: 1rem;
    padding: 0.5rem 1.6rem;
    border: 1px solid #d2d2d2;
    border-radius: 1rem;

    color: inherit;
    background: transparent;
    font-size: 20px;
    font-family: inherit;
    letter-spacing: 0.2rem;

    transition: 0.2s;
    cursor: pointer;
}

.modal__btn:nth-of-type(1) {
    margin-right: 1rem;
}

.modal__btn:hover,
.modal__btn:focus {
    background: var(--focus);
    border-color: var(--focus);
    transform: translateY(-0.2rem);
}

.btn__close__modal {
    box-shadow: 0px 0px 2px 1px #888888;
    width: 4rem;
    height: 4rem;
    border: 1px solid var(--border-color);
    border-radius: 100rem;

    color: inherit;
    font-size: 2.2rem;

    position: absolute;
    top: 1rem;
    right: 1rem;

    display: flex;
    justify-content: center;
    align-items: center;

    transition: linear 0.5s;
    cursor: pointer;
}

.btn__close__modal::before {
    content: "×";
    transform: translateY(0rem);
}

.btn__close__modal:hover,
.btn__close__modal:focus {
    background: #718093;
    transform: translateY(-0.2rem);
}
.modal__content .card {
    display: flex;
    background-color: #ffffff;
    border-radius: 10px;
    margin-left: 1rem;
    margin-top: 0;
    box-shadow: 0px 0px 2px 1px #888888;
    cursor: pointer;
    transition: linear 0.5s;
    margin-bottom: 0.5rem !important;
}
.modal__content.nqt__mb {
    width: 100% !important;
    grid-template-columns: none !important;
    max-height: 398px !important;
}
.modal.nqt__mb {
    max-height: 453px !important;
}
.modal__content .card:hover {
    transform: scale(0.99);
}
.modal__content .card .avatar {
    padding: 5px;
    width: 50px;
}
.modal__content .card img {
    width: 100%;
    border-radius: 20px;
}
.modal__content .card .card__content {
    padding: 4px 1rem;
    padding-top: 6px;
    font-size: 10px;
    width: calc(100% - 80px);
}
.modal__content .card .card__content .card__name {
    font-weight: 700;
    font-size: 14px;
    color: black;
}
.modal__content .card .card__content .card__email {
    color: #686f73;
}

.modal__content {
    display: grid;
    padding: 5px;
    overflow: auto;
    max-height: 287px;
    margin-top: 10px;
}
.modal__content.leng1 {
    grid-template-columns: auto auto;
}

.bg__close__modal {
    background: #29262687;
    left: 0;
    top: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.nqt__mb .modal__title {
    font-size: 20px;
}
.nqt__mb .btn__close__modal {
    top: 10px;
    width: 27px;
    height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/studentsLive.vue